<template>	

		<div class="knd-pensioenstats">
			<img :src='require("@/assets/img/opaomastrand.png")' class="opaomastrand" />

			<div class="pensioenstats-tekst">
				<h2>WAARIN EN HOEVEEL INVESTEERT JOUW PENSIOENFONDS?</h2>
				<p class="knd-klein">Kies je pensioenfonds in de lijst om te zien hoe vies het investeert</p>

				<Dropdown :data="data" :name="'pensioenfonds'" @gekozen="selectFonds" />

				<div v-if='getFonds() && getFonds()["pensioenfonds"] === "StiPP"'>
					<p>StiPP geeft geen informatie over de beleggingen.</p>
				</div>
			</div>

			
		</div>

		<div ref="optellingen-wrapper" class="knd-optellingen-wrapper" v-show='getFonds() && getFonds()["pensioenfonds"] !== "StiPP"'>
			<div ref="optellingen" class="knd-optellingen">
				<div 
					class="knd-optelling samenvatting" 
					v-if='getFonds() && (getFonds()["pensioenfonds"] !== "Vervoer") && (getFonds()["pensioenfonds"] !== "PNO")'>
					<p>Investeert in de <br/>fossiele industrie voor</p>
					<h4 class="geel">€ <span v-html="getFonds()['euro_per_deelnemer']"></span></h4>
					<p>per deelnemer</p><br/>
					<p class="knd-klein">Beleggingsportefeuille <br/>van {{ getFonds()['datum'] }}</p>
				</div>

				<div 
					class="knd-optelling samenvatting" 
					v-if='getFonds() && (getFonds()["pensioenfonds"] === "Vervoer") || getFonds() && (getFonds()["pensioenfonds"] === "PNO")'>
					<p>Pensioenfonds <span v-html="getFonds()['pensioenfonds']"></span> <br/>geeft geen hoogte van de <br/>investeringen in euro's</p><br/>
					<p class="knd-klein">Beleggingsportefeuille <br/>van {{ getFonds()['datum'] }}</p>
				</div>

				<div 
					class="knd-optelling"
					v-if='getFonds()'>
					<img :src='require("@/assets/img/steenkool.png")' class="optelling-plaatje" />
					<h4>Steenkool</h4>
					<p>Aantal bedrijven: <span v-html="getFonds()['totaal_bedrijven_coal']"></span></p>
					<p v-if='(getFonds()["pensioenfonds"] !== "Vervoer") && (getFonds()["pensioenfonds"] !== "PNO")'>
						Totale bedrag: €<span v-html="niceRound(getFonds()['totaal_euro_coal'])"></span>
					</p>
				</div>

				<div 
					class="knd-optelling"
					v-if='getFonds()'>
					<img :src='require("@/assets/img/wiel.png")' class="optelling-plaatje" />
					<h4>Olie- of gaswinning</h4>
					<p>Aantal bedrijven: <span v-html="getFonds()['totaal_bedrijven_upstream']"></span></p>
					<p 
						v-if='(getFonds()["pensioenfonds"] !== "Vervoer") && (getFonds()["pensioenfonds"] !== "PNO")'>
						Totale bedrag: €<span v-html="niceRound(getFonds()['totaal_euro_upstream'])"></span>
					</p>
				</div>

				<div 
					class="knd-optelling"
					v-if='getFonds()'>
					<img :src='require("@/assets/img/gastanker.png")' class="optelling-plaatje" />
					<h4>Olie- of gastransport</h4>
					<p>Aantal bedrijven: <span v-html="getFonds()['totaal_bedrijven_midstream']"></span></p>
					<p v-if='(getFonds()["pensioenfonds"] !== "Vervoer") && (getFonds()["pensioenfonds"] !== "PNO")'>
						Totale bedrag: €<span v-html="niceRound(getFonds()['totaal_euro_midstream'])"></span>
					</p>
				</div>
			</div>
		</div>

		<!-- <div class="knd-scrollbar-wrapper" v-if='getFonds() && getFonds()["pensioenfonds"] !== "StiPP"'>
			<Scrollbar :elem="getRef('optellingen-wrapper')" :childElem="getRef('optellingen')" />
		</div> -->

</template>

<script>
	import './pensioenstats.scss';

	import Dropdown from './../dropdown/dropdown';
	// import Scrollbar from './../scrollbar/scrollbar';

	export default {
		name: 'Colofon',
		computed: {
		},
		data: function() {
			return {
				content: this.$store.state.content,
				data: this.$store.state.data,
				optellingen: this.$refs.optellingen
			}
		},
		mounted() {
			console.log("refs, ", this.$refs);
		},
		watch: {
			// '$store.state.selectedFonds': {
			// 	deep: true,
			// 	handler(newVal) {
			// 		this.$forceUpdate();
			// 	}
			// }
		},
		methods: {
			getContent(content, label) {
				// if (this.$store.state.language === "nl") {
					return content[label].data;
				// }
				// else {
					// return content[label].data5891;	
				// }
			},

			niceRound(value) {
				let devide = null;
				let eenheid = null;

				if (value < 100000000) {
					devide = Math.round((value / 10000)) / 100;	
					eenheid = "mln";
				}
				else {
					devide = Math.round((value / 10000000)) / 100;
					eenheid = "mrd";
				}
				
				const toDec = devide.toFixed(1)
				const toNL = toDec.toString().replace(".", ",");
				return toNL + " " + eenheid;
			},

			getFondsClass(fonds) {
				if (this.getFonds() && fonds["pensioenfonds"] === this.getFonds()["pensioenfonds"]) {
					return "selected";
				}
			},

			selectFonds(fonds) {
				console.log("het gekozen fonds is", fonds);
				this.$store.dispatch('updateFonds', fonds);
			},

			
			getFonds() {
				return this.$store.getters.selectedFonds;
			},

			//nodig omdat vue het anders niet goed doorgeeft
			//https://github.com/vuejs/composition-api/issues/317
			getRef(ref) {
				return this.$refs[ref];
			}
		},
		components: {
			Dropdown,
			// Scrollbar
		}
	}
</script>